import { useState } from "react";
import styles from "./AddOtherItemModal.module.css";
import Button from "../components/Button";
import { validateForm } from "../helpers/helperFunctions";
import React from "react";

function AddOtherItemModal({ eventData, setEventData, bID, makeInvalid }) {
  const [isOpen, setIsOpen] = useState(false);
  //const navigate = useNavigate();

  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [isGrat, setIsGrat] = useState(false);

  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setIsOpen((x) => !x);
    setDescription("");
    setPrice("");
  };

  const addOtherItem = async (e) => {
    e.preventDefault();
    if (validateForm(e.target)) {
      const formData = new URLSearchParams({
        id: bID,
        description: description,
        price: price,
        gratPercent: eventData.percentGrat,
      });
      await fetch("/api/detail/addother", {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          setEventData({
            ...eventData,
            otherTotal: data.priceUpdate.otherTotal,
            serviceTotal: data.priceUpdate.serviceTotal,
            details: data.details,
          });
        });
      //await getDetail();
      closeModal();
    }
  };

  return (
    <>
      <Button type="tertiary" onClick={openModal}>
        Add Other Item/Charge
      </Button>
      {isOpen && (
        <div className="modal-backdrop modal-backdrop-dark">
          <div className={`modal-content ${styles.modalTop}`}>
            <h3 className="modal-header">Add Other Item/Charge</h3>

            <form className={styles.otherMenuItemForm} onSubmit={addOtherItem} noValidate>
              <h4>Add other item/charge</h4>
              <div className={styles.otherMenuItemBody}>
                <div className={styles.formSection}>
                  <input
                    type="text"
                    className={styles.otherDesc}
                    name="description"
                    placeholder="Enter description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    onInvalid={makeInvalid}
                  />
                  <div className="invalid-feedback">Item name required</div>
                </div>
                <div className={styles.formSection}>
                  <input
                    type="number"
                    className={styles.otherPrice}
                    name="price"
                    step=".01"
                    value={price}
                    placeholder="Enter price"
                    onChange={(e) => setPrice(Number(e.target.value))}
                    required
                    onInvalid={makeInvalid}
                  />
                  <div className="invalid-feedback">Item price required</div>
                </div>
              </div>
              <div className={styles.formSelectButtons}>
                <Button type="secondary">Add Other Item</Button>
                <Button type="save" onClick={closeModal}>
                  Close
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default AddOtherItemModal;
